// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "practitioner_wage_config".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { wageAutomationSettingValues, wageCompensationTypeValues, wageOvertimeTypeValues, wageRegularHoursPerValues } from '@borradh-workspace/labels';
/** Response atom for the "practitioner_wage_config" table (1:1 with a DB row, on the wire). */
export const practitionerWageConfigAtomSchema = z.object({
    practitionerId: z.string(),
    organizationId: z.string(),
    compensationType: z.enum(wageCompensationTypeValues),
    hourlyRateCents: z.number().nullable(),
    overtimeEnabled: z.boolean(),
    regularWorkHours: z.number().nullable(),
    regularWorkHoursPer: z.enum(wageRegularHoursPerValues),
    overtimeType: z.enum(wageOvertimeTypeValues).nullable(),
    overtimeMultiplier: z.number().nullable(),
    overtimeHourlyRateCents: z.number().nullable(),
    autoClockIn: z.enum(wageAutomationSettingValues),
    autoClockOut: z.enum(wageAutomationSettingValues),
    automatedBreaks: z.enum(wageAutomationSettingValues),
    locationRestriction: z.enum(wageAutomationSettingValues),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=practitionerWageConfig.js.map